import Sidebar from "../../Components/Sidebar";
import Button from "@mui/material/Button";
import { IoIosMenu } from "react-icons/io";
import { CgMenuGridR } from "react-icons/cg";
import { HiViewGrid } from "react-icons/hi";
import { TfiLayoutGrid4Alt } from "react-icons/tfi";
import { FaAngleDown } from "react-icons/fa6";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useContext, useEffect, useState } from "react";
import ProductItem from "../../Components/ProductItem";
import NoProductsFound from "../../Components/NoProductsFound";
import Pagination from "@mui/material/Pagination";

import { useParams } from "react-router-dom";
import { fetchDataFromApi } from "../../utils/api";
import CircularProgress from "@mui/material/CircularProgress";
import { FaFilter } from "react-icons/fa";
import { MyContext } from "../../App";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
const SearchPage = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [productView, setProductView] = useState("four");
  const [productData, setProductData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const openDropdown = Boolean(anchorEl);
  const [isOpenFilter, setIsOpenFilter] = useState(false);

  const context = useContext(MyContext);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setisLoading(true);
    setTimeout(() => {
      setProductData(context.searchData);
      setisLoading(false);
    }, 3000);

    context.setEnableFilterTab(false);
  }, [context.searchData]);

  const filterData = (subCatId) => {
    setisLoading(true);

    fetchDataFromApi(`/api/products?subCatId=${subCatId}`).then((res) => {
      setProductData(res.products);
      setisLoading(false);
    });
  };

  const filterByPrice = (price, subCatId) => {
    setisLoading(true);

    fetchDataFromApi(
      `/api/products?minPrice=${price[0]}&maxPrice=${price[1]}&subCatId=${subCatId}`
    ).then((res) => {
      setProductData(res.products);
      setisLoading(false);
    });
  };

  const filterByRating = (rating, subCatId) => {
    setisLoading(true);
    fetchDataFromApi(
      `/api/products?rating=${rating}&subCatId=${subCatId}`
    ).then((res) => {
      setProductData(res.products);
      setisLoading(false);
    });
  };

  const openFilters = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const query = params.get("q"); // if your search URL looks like /search?q=apple

  return (
    <>
      <Helmet>
        <meta
          property="og:title"
          content={
            query
              ? `Search results for "${query}" - SabbaFarm | Sabba Farm`
              : "Search Products - SabbaFarm | Sabba Farm"
          }
        />
        <meta
          property="og:description"
          content={
            query
              ? `Find the best results for "${query}" on SabbaFarm (Sabba Farm). Discover quality items and best deals.`
              : "Search and explore quality products on SabbaFarm (Sabba Farm)."
          }
        />

        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content={
            query
              ? `Search results for "${query}" - SabbaFarm`
              : "Search Products - SabbaFarm"
          }
        />
        <meta
          property="og:description"
          content={
            query
              ? `Find the best results for "${query}" on SabbaFarm. Discover quality items and best deals.`
              : "Search and explore quality products on SabbaFarm."
          }
        />
        <meta
          property="og:url"
          content={`https://sabbafarm.com/search${location.search}`}
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <section className="product_Listing_Page">
        <div className="container">
          <div className="productListing d-flex">
            <Sidebar
              filterData={filterData}
              filterByPrice={filterByPrice}
              filterByRating={filterByRating}
              isOpenFilter={isOpenFilter}
            />

            <div className="content_right">
              <div className="showBy mt-0 mb-3 d-flex align-items-center">
                <div className="d-flex align-items-center btnWrapper">
                  <Button
                    className={productView === "one" && "act"}
                    onClick={() => setProductView("one")}
                  >
                    <IoIosMenu />
                  </Button>

                  <Button
                    className={productView === "three" && "act"}
                    onClick={() => setProductView("three")}
                  >
                    <CgMenuGridR />
                  </Button>
                  <Button
                    className={productView === "four" && "act"}
                    onClick={() => setProductView("four")}
                  >
                    <TfiLayoutGrid4Alt />
                  </Button>
                </div>
              </div>

              <div className="productListing">
                {isLoading === true ? (
                  <div className="loading d-flex align-items-center justify-content-center">
                    <CircularProgress color="inherit" />
                  </div>
                ) : (
                  <>
                    {Array.isArray(productData) && productData.length > 0 ? (
                      productData.map((item, index) => (
                        <ProductItem
                          key={index}
                          itemView={productView}
                          item={item}
                        />
                      ))
                    ) : (
                      <NoProductsFound />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SearchPage;
